export function uniqid(a = "", b = false) {
    var c = Date.now() / 1000;
    var d = c.toString(16).split(".").join("");
    while (d.length < 14) {
        d += "0";
    }
    var e = "";
    if (b) {
        e = ".";
        var f = Math.round(Math.random() * 100000000);
        e += f;
    }
    return a + d + e;
}


export function getsuffix(filename) {
    let pos = filename.lastIndexOf('.');
    let suffix = '';
    if (pos !== -1) {
        suffix = filename.substring(pos);
    }
    return suffix;
}


export function parseQueryString(url) {

    let quora = url.indexOf('?');
    let lens = url.length;
    let paramstring = url.substr(quora + 1, lens);
    //console.log(paramstring)
    //console.log(paramstring.split('&'))
    const params = new Map(paramstring.split('&').map(param => param.split('=')));
    //console.log(params)
    //console.log(params.get('type'))
    return params;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js